import { Placeholder } from "@tiptap/extensions";
import type { Extensions } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

export function createExtensions(placeholder?: string): Extensions {
  return [
    StarterKit.configure({
      blockquote: false,
      code: false,
      codeBlock: false,
      heading: false,
      horizontalRule: false,
      trailingNode: false,
      link: {
        openOnClick: false,
        autolink: true,
        defaultProtocol: "https",
        HTMLAttributes: { rel: "noopener noreferrer", target: "_blank" },
      },
    }),
    ...(placeholder === undefined
      ? []
      : [Placeholder.configure({ placeholder })]),
  ];
}
